import { Box, Text } from "@mantine/core";
import logoMarkUrl from "../assets/logo-mark.png";
import logoLockupUrl from "../assets/logo-lockup.png";

interface LogoProps {
  /** true = full lockup (official logo with embedded wordmark); false = emblem-only mark. */
  showWordmark?: boolean;
  /** Add an "admin" subscript under the lockup. */
  variant?: "default" | "admin";
  /** Height of the rendered logo image in px. Width is computed from the asset's exact aspect. */
  size?: number;
}

/** Exact source dimensions — used to compute width so images are NEVER
 *  left at width:auto (a width:auto img inside a flex-direction:column
 *  parent gets cross-axis-stretched: measured 2:1 distortion on the
 *  login hero. Explicit width + height makes distortion impossible). */
const MARK = { w: 235, h: 128 };
const LOCKUP = { w: 462, h: 256 };

/**
 * ProxVPS brand logo, from Sam's official assets:
 * - Full lockup (default): emblem + embedded "ProxVPS" wordmark — the
 *   actual logo.png artwork, used wherever the brand appears in full.
 * - Emblem-only mark (showWordmark={false}): for the collapsed icon rail,
 *   sized to match the nav icons.
 * The "admin" variant keeps a small HTML subscript under the lockup.
 */
export function Logo({ showWordmark = true, variant = "default", size = 56 }: LogoProps) {
  if (!showWordmark) {
    return (
      <Box
        component="img"
        src={logoMarkUrl}
        alt="ProxVPS"
        style={{
          height: size,
          width: Math.round((size * MARK.w) / MARK.h),
          display: "block",
          flex: "0 0 auto",
        }}
      />
    );
  }

  return (
    <Box style={{ lineHeight: 1, flex: "0 0 auto" }}>
      <Box
        component="img"
        src={logoLockupUrl}
        alt="ProxVPS"
        style={{
          height: size,
          width: Math.round((size * LOCKUP.w) / LOCKUP.h),
          display: "block",
        }}
      />
      {variant === "admin" && (
        <Text fz={10} fw={500} c="dimmed" mt={6}>
          admin console
        </Text>
      )}
    </Box>
  );
}
